import {createSelector, createSlice} from "@reduxjs/toolkit";
import {selectAllWallets} from "./walletSlice";


const initialState = {
    budgets: []
}

const budgetSlice = createSlice({
    name: 'budget',
    initialState: initialState,
    reducers: {
        loadBudgetsSuccess(state, action) {
            return {...state, budgets: action.payload}
        },
        updateBudgetSuccess(state, action) {
            const savedBudget = action.payload;
            const budgets = [...state.budgets];
            let isBudgetChanged = false;

            budgets.forEach((budget, index) => {
                if (budget.id === savedBudget.id) {
                    budgets[index] = savedBudget;
                    isBudgetChanged = true;
                }
            });
            if (!isBudgetChanged) {
                budgets.push(savedBudget);
            }
            return {...state, budgets: budgets}
        },
        deleteBudgetSuccess(state, action) {
            const id = action.payload;
            const budgets = state.budgets.filter(budget => budget.id != id);
            return {...state, budgets: budgets}
        }
    }
})

export const {loadBudgetsSuccess, updateBudgetSuccess, deleteBudgetSuccess} = budgetSlice.actions
export default budgetSlice.reducer


export const fetchBudgets = () => async (dispatch, getState) => {
    fetch('/api/budgets')
        .then((response) => {
            if (response.ok) {
                response.json().then(json =>
                    dispatch(loadBudgetsSuccess(json)));
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export const saveBudget = (budget, onSuccess) => async (dispatch, getState) => {
    fetch('/api/budgets', {
        method: "PUT",
        body: JSON.stringify(budget),
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((response) => {
            if (response.ok) {
                response.json().then(json => {
                    dispatch(updateBudgetSuccess(json));
                    if(onSuccess) {
                        onSuccess();
                    }
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export const deleteBudget = (budget, onSuccess) => async (dispatch, getState) => {
    fetch('/api/budgets?id=' + budget.id, {
        method: "DELETE",
        // body: JSON.stringify(wallet),
    })
        .then((response) => {
            if (response.ok) {
                response.json().then(json => {
                    dispatch(deleteBudgetSuccess(budget.id));
                    if(onSuccess) {
                        onSuccess();
                    }
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

// export const selectBudgets = (state) => {
//     return state.budgetSlice.budgets ? state.budgetSlice.budgets.filter(eachBudget => eachBudget.active) : []
// }

// export const selectBudgetsOrSelected = (state, selectedBudgetId) => {
//     return state.budgetSlice.budgets ? state.budgetSlice.budgets.filter(eachBudget => eachBudget.active || eachBudget.id === selectedBudgetId) : []
// }

export const selectAllBudgets = (state) => {
    return state.budgetSlice.budgets
}

export const selectBudgetsOrSelected = createSelector(
    [selectAllBudgets, (state, selectedBudgetId) => selectedBudgetId], (budgets, selectedBudgetId) => {
        return budgets ? budgets.filter(eachBudget => eachBudget.active || eachBudget.id === selectedBudgetId) : []
    })

export const selectBudget = (state, budgetId) =>
    state.budgetSlice.budgets ? state.budgetSlice.budgets.find(budget => budget.id === budgetId) : undefined;


